import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { OrganizationCountsWidget } from "./OrganizationCountsWidget";
import {
  getDonationFavAmount,
  getStats,
  getGrandTotal,
  getTopOrgDonation,
  getTotalDonation,
  getTopOrgbyDonor,
  getTotalDonor,
  getTotalDonationCount,
  getDonationYearTarget,
  getGradeOrg
} from "../../_redux/dashboard/dashboardCrud";
import { toastOption } from "../../../../../_metronic/_helpers";
import { OrganizationGrowthCharts } from "./OrganizationGrowthCharts";
import { OrganizationGradeWidget } from "./OrganizationGradeWidget";
import { ConsolidationSumsWidget } from "./ConsolidationSumsWidget";
import { GrandTotalWidget } from "./GrandTotalWidget";
import DonationFavoriteAmount from "./DashboardWidget/DonationFavoriteAmount";
import TotalDonation from "./DashboardWidget/TotalDonation";
import { TableDashboard } from "./DashboardWidget/TableDashboard";
import OrgTotalDonation from "./DashboardWidget/OrgTotalDonation";
import TotalDonor from "./DashboardWidget/TotalDonor";
import { useSelector } from "react-redux";
import TotalDonorCount from "./DashboardWidget/TotalDonorCount";
import TotalDonationCount from "./DashboardWidget/TotalDonationCount";
import { TilesDonationWidget } from "../../../Dashboard/Component/FirstRow/TilesDonationWidget";

const backgroundImageUrl = toAbsoluteUrl("/media/stock-600x600/img-16.jpg");

export default function DashboardPage({ history }) {
  const { user } = useSelector(({ auth }) => ({
    user: auth.user
  }));

  const [loading, setLoading] = useState({
    stats: false,
    data: false
  });

  const [orgCounts, setOrgCounts] = useState({
    all_count: 0,
    active_count: 0,
    registration_count: 0,
    inactive_count: 0
  });

  const [orgGrade, setOrgGrade] = useState({
    totalGradeBronze: 0,
    totalGradeSilver: 0,
    totalGradeGold: 0,
    totalGradePlat: 0,
    items: [],
  });

  const [consdSums, setConsdSums] = useState({
    total_zakat: 0,
    total_infaq: 0,
    total_alms: 0
  });

  const [grandTotal, setGrandTotal] = useState({
    total_zakat: 0,
    total_infaq: 0,
    total_alms: 0
  });
  const [orgGrowth, setOrgGrowth] = useState([]);
  const [consdGrowth, setConsdGrowth] = useState([]);

  const [params, setParams] = useState({
    period_name: "Tahun",
    period_type: "year"
  });

  const [donorCountParams, setDonorCountParams] = useState({
    timeBased: ""
  });

  const [dashboardData, setDashboardData] = useState({
    favoriteAmount: [],
    totalDonation: [],
    topOrgDonation: [],
    topOrgDonor: [],
    totalDonorCount: 0,
    totalDonationCount: 0,
    achivementYearlyTarget: {
      donation: 0,
      donation_percentage: 0,
      growth: 0,
      besaranHimpunan: 0
    }
  });

  useEffect(() => {
    fetchStats({
      period_type: params.period_type,
      regional_uuid: user.regional_uuid
    });

    fetchGrandTotal({
      regional_uuid: user.regional_uuid
    })

    fetchGradeOrg()
  }, [params]);

  useEffect(() => {
    fetchDashboardData();
    // fetchGradeOrg();
  }, []);

  useEffect(() => {
    fetchTotalDonor({
      timeBased: donorCountParams.timeBased
    });
  }, [donorCountParams.timeBased, params]);

  function handleOpenLoading(key) {
    setLoading(prev => ({
      ...prev,
      [key]: true
    }));
  }

  function handleCloseLoading(key) {
    setLoading(prev => ({
      ...prev,
      [key]: false
    }));
  }

  async function fetchDashboardData() {
    try {
      handleOpenLoading("data");
      // * Get Donation Favorite Amount
      const { data: favoriteAmountData } = await getDonationFavAmount();

      // * Get Total Donation
      const typeList = ["today", "this_week", "this_month"];
      const totalDonationData = [];
      for (const type of typeList) {
        const attr = {
          label: "",
          icon: "",
          color: ""
        };
        switch (type) {
          case "today":
            attr.label = "Donasi Hari Ini";
            attr.icon = "fas fa-calendar-day";
            attr.color = "#FC1754";
            break;
          case "this_week":
            attr.label = "Donasi Minggu Ini";
            attr.icon = "fas fa-calendar-week";
            attr.color = "#247B9E";
            break;
          case "this_month":
            attr.label = "Donasi Bulan Ini";
            attr.icon = "fas fa-calendar-alt";
            attr.color = "#1BC5BD";
            break;
          case "this_year":
            attr.label = "Donasi Tahun Ini";
            attr.icon = "fas fa-calendar-days";
            attr.color = "#FC1754";
            break;
          case "overall":
            attr.label = "Donasi Keseluruhan";
            attr.icon = "fas fa-calendar-clock";
            attr.color = "#1BC5BD";
            break;

          default:
            attr.label = "";
            attr.icon = "";
            attr.color = "";
            break;
        }
        const {
          data: {
            data: { total_donation_amount }
          }
        } = await getTotalDonation(type);
        totalDonationData.push({
          attr,
          total_donation_amount
        });
      }

      // * Get Top 10 organization by donation
      const {
        data: { data: topOrgDonation }
      } = await getTopOrgDonation();

      // * Get Top 10 organization by donor
      const {
        data: { data: topOrgDonor }
      } = await getTopOrgbyDonor();

      // * Get total donor count
      const {
        data: { data: donorCount }
      } = await getTotalDonor();

      // * Get total donation count
      const {
        data: { data: donationCount }
      } = await getTotalDonationCount();

      const {
        data: { data: donationYearTarget }
      } = await getDonationYearTarget();

      setDashboardData(prev => ({
        ...prev,
        favoriteAmount: favoriteAmountData.data,
        totalDonation: totalDonationData,
        topOrgDonation,
        topOrgDonor,
        totalDonorCount: donorCount,
        totalDonationCount: donationCount,
        achivementYearlyTarget: {
          growth: donationYearTarget.pertumbuhan,
          donation_percentage: donationYearTarget.persen_target ?? 0,
          donation: donationYearTarget.target,
          besaranHimpunan: donationYearTarget.besaran_himpunan
        }
      }));
    } catch (error) {
      console.log(error);
    } finally {
      handleCloseLoading("data");
    }
  }

  async function fetchStats(params) {
    try {
      handleOpenLoading("stats");

      const { data: { data = {} } = {} } = await getStats(params);
      const {
        organization_count: [counts = []] = {},
        organization_report: [reports = []] = {},
        organization_growth = [],
        consolidation_growth = []
      } = data ?? {};

      const {
        all_count,
        active_count,
        registration_count,
        inactive_count
      } = counts;

      const { total_zakat, total_infaq, total_alms } = reports;

      setOrgCounts({
        all_count,
        active_count,
        registration_count,
        inactive_count
      });
      setConsdSums({ total_zakat, total_infaq, total_alms });
      setOrgGrowth(organization_growth);
      setConsdGrowth(consolidation_growth);
    } catch (error) {
      toast.error(error.message, toastOption);
    } finally {
      handleCloseLoading("stats");
    }
  }

  async function fetchTotalDonor(params) {
    try {
      const {
        data: { data: donorCount }
      } = await getTotalDonor(params);

      setDashboardData(prev => ({
        ...prev,
        totalDonorCount: donorCount
      }));
    } catch (error) {
      toast.error(error.message, toastOption);
    }
  }

  async function fetchGrandTotal(params) {
    try {
      const res = await getGrandTotal(params);
      const data = res.data.data

      setGrandTotal({
        total_alms: data.total_alms,
        total_infaq: data.total_infaq,
        total_zakat: data.total_zakat
      });

    } catch (err) {
      toast.error(err.message, toastOption);
    }
  }

  async function fetchGradeOrg() {
    try {
      const res = await getGradeOrg();
      const data = res.data.data

      setOrgGrade({
        totalGradeBronze: data.totalGradeBronze,
        totalGradeSilver: data.totalGradeSilver,
        totalGradeGold: data.totalGradeGold,
        totalGradePlat: data.totalGradePlat,
        items: data.items,
      })

    } catch (err) {
      toast.error(err.message, toastOption);
    }
  }

  function updateParams({ period_name, period_type }) {
    setConsdGrowth([]);
    setOrgGrowth([]);
    setParams(prev => ({ ...prev, period_name, period_type }));
  }

  function updateDonorCountParam(params) {
    setDonorCountParams(prev => ({ ...prev, timeBased: params }));
  }

  return (
    <div>
      <div
        className={`card card-custom bgi-no-repeat bgi-size-cover`}
        style={{
          backgroundImage: `url("${backgroundImageUrl}")`
        }}
      >
        <div className="card-body d-flex flex-column align-items-start justify-content-start">
          <div className="p-1 flex-grow-1">
            <h3 className="text-white font-weight-bolder line-height-lg mb-5">
              Selamat Datang {user.name ? `- ${user.name}` : ""}
              <br />
              {user.role ?? ""}
            </h3>
          </div>
        </div>
      </div>
      <OrganizationCountsWidget
        loading={loading.stats}
        org_counts={orgCounts}
      />
      <OrganizationGradeWidget
        loading={loading.stats}
        org_grade={orgGrade}
      />
      <GrandTotalWidget
        loading={loading.stats}
        grand_total={grandTotal}
      />
      <ConsolidationSumsWidget
        loading={loading.stats}
        consolidation_sums={consdSums}
        period_type={params.period_type}
      />
      <div className="row">
        <div className="col-lg-4">
          <TilesDonationWidget
            className="gutter-b"
            widgetHeight="430px"
            persen={dashboardData.achivementYearlyTarget.donation_percentage}
            loading={loading.data}
            pertumbuhan={dashboardData.achivementYearlyTarget.growth}
            target={dashboardData.achivementYearlyTarget.donation}
            besaranHimpunan={
              dashboardData.achivementYearlyTarget.besaranHimpunan
            }
            chartID="capaianTargetTahunan"
          />
        </div>
        <div className="col-lg-4">
          <TotalDonorCount
            donorCount={dashboardData.totalDonorCount}
            handleChangeParams={updateDonorCountParam}
          />
        </div>
        <div className="col-lg-4">
          <TotalDonationCount
            donationCount={dashboardData.totalDonationCount}
          />
        </div>
      </div>
      <OrganizationGrowthCharts
        loading={loading.stats}
        organization_growth={orgGrowth}
        consolidation_growth={consdGrowth}
        params={params}
        updateParams={updateParams}
      />
      <TotalDonation
        data={dashboardData.totalDonation}
        loading={loading.data}
      />
      <div className="row p-0 mb-10">
        <div className="col-lg-4 col-sm-12 mb-10 mb-md-0">
          <OrgTotalDonation />
        </div>
        <div className="col-lg-4 col-sm-12 mb-10 mb-md-0">
          <TableDashboard
            title="Top 10 Lembaga Berdasarkan Donasi"
            tableHeader={[
              { label: "Nama Lembaga", classes: "text-left" },
              { label: "Jumlah Donasi", classes: "text-right" }
            ]}
            data={dashboardData.topOrgDonation}
            loading={loading.data}
          />
        </div>
        <div className="col-lg-4 col-sm-12">
          <TotalDonor
            title="Top 10 Lembaga Berdasarkan Donatur"
            data={dashboardData.topOrgDonor}
            tableHeader={[
              { label: "Nama Lembaga", classes: "text-left" },
              { label: "Jumlah Donatur", classes: "text-center" }
            ]}
            loading={loading.data}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <DonationFavoriteAmount data={dashboardData.favoriteAmount} />
        </div>
      </div>
    </div>
  );
}
